import Heading from 'shopper/components/Heading';

import placeholder from 'lib/placeholder';

import Card from './Card';
import CardHeading from './Heading';

const OFF_SITE_TAGS = [
  {
    icon: 'email',
    text: 'Email MKT',
  },
  {
    icon: 'notification-ring',
    text: 'Push',
  },
  {
    icon: 'radio',
    text: 'Conteúdo Influencers',
  },
  {
    icon: 'facebook',
    text: 'Redes Sociais',
  },
  {
    icon: 'telegram',
    text: 'Telegram',
  },
  {
    icon: 'phone',
    text: 'Live',
  },
  {
    icon: 'mic-external',
    text: 'Spot Rádio',
  },
];

const BlueCard = () => (
  <div className="flex flex-col-reverse items-center justify-end gap-x-6 gap-y-2 overflow-hidden md:flex-row md:gap-y-0">
    <Heading as="h3" className="text-gradient-highlight" size="size1">
      {placeholder('titles.awareness')}
    </Heading>
    <Card
      heading={
        <CardHeading subtitle="Audiência Qualificada" title="OFF Site" />
      }
      tags={OFF_SITE_TAGS}
      type="primary"
    />
  </div>
);

export default BlueCard;
